<template>
  <v-bottom-navigation
    :active="active"
    :grow="true"
    tag="nav"
    aria-label="Bottom navigation"
    class="fixed nav-bar"
    :height="80"
    :elevation="0"
    bg-color="surface-container"
  >
    <v-btn
      v-for="item in items"
      :key="item.value"
      :to="{ name: item.value }"
      :active="isActive(item.value)"
      color="on-surface"
    >
      <!-- Material 3 navigation bar: a pill behind the active icon -->
      <span class="indicator">
        <v-icon>{{ item.icon }}</v-icon>
      </span>
      <span class="label">{{ item.title }}</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script lang="ts">
  import { defineComponent, type PropType } from 'vue';
  import type { MenuItem } from '@/components/infrastructure/nav-drawer/NavDrawer.vue';
  import { useRouter } from 'vue-router';

  export default defineComponent({
    name: 'NavBottom',
    props: {
      active: Boolean,
      items: Object as PropType<MenuItem[]>,
    },
    setup() {
      const router = useRouter();
      return {
        isActive(name: string): boolean {
          return router.currentRoute.value.matched.some(
            (route) => route.name === name,
          );
        },
      };
    },
  });
</script>

<style scoped>
  .fixed {
    position: fixed !important;
  }

  .nav-bar :deep(.v-btn__overlay) {
    display: none;
  }

  .indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 32px;
    margin-bottom: 4px;
    border-radius: 16px;
  }

  .v-btn--active .indicator {
    background: rgb(var(--v-theme-secondary-container));
    color: rgb(var(--v-theme-on-secondary-container));
  }

  .indicator,
  .label {
    color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  }

  .label {
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    letter-spacing: 0.03125em;
  }

  .v-btn--active .label {
    color: rgb(var(--v-theme-on-surface));
    font-weight: 700;
  }
</style>
